module.exports = __webpack_public_path__ + "static/img/SetBannerM.53b419b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SetBannerM.png
// module id = 57Bf
// module chunks = 1